import { Component, Input, OnInit, Output, EventEmitter } from "@angular/core";
import { IDropdownSettings } from "ng-multiselect-dropdown";

@Component({
  selector: "app-multiselect",
  templateUrl: "./multiselect.component.html",
  styleUrls: ["./multiselect.component.scss"],
})
export class MultiselectComponent implements OnInit {
  @Input() data: any;
  @Input() name: any;
  @Input() defauld: any;
  @Input() id: any;
  @Input() placeholder: any;
  @Input() disabled: Boolean;
  @Input() singleSelection: boolean;
  @Output() selected = new EventEmitter();
  dropdownSettings: IDropdownSettings;
  @Input() reset: boolean;
  @Input() selectedData: any;
  @Input() selection: boolean;
  selectedSupplier = new Array();
  count = 0;

  constructor() { }

  ngOnInit() {
    // debugger
    if (this.reset == true) {
      this.selected.emit([]);
    }

    if (typeof this.selection == "undefined") {
      this.selection = false;
    }

    this.dropdownSettings = {
      singleSelection: this.selection,
      idField: "id",
      textField: this.name,
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 3,
      allowSearchFilter: true,
    };
  }
  ngDoCheck(){
    try {
     // console.log('defauld', this.defauld, this.defauld.length);
     if(this.defauld){
       if(this.count === 0 && this.defauld.length > 0){
         this.selectedSupplier = [];
         this.selectedSupplier = this.defauld;
         this.count += 1;
        }
      }
    } catch (error) {
      
    }
    
  }

  onItemSelect(item: any) {
    console.log(item);
    this.selected.emit(this.selectedData);
  }

  onSelectAll(items: any) {
    this.selected.emit(items);
  }

  onItemDeSelect(items: any) {
    this.selected.emit(this.selectedData);
  }
  onDeSelectAll(items: any) {
    this.selected.emit(items);
  }
  







  
}
